import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Track page view
    const trackPageView = async () => {
      try {
        await axios.post(`${API}/track`, {
          page: location.pathname,
          user_agent: navigator.userAgent,
          referrer: document.referrer || null
        });
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Tracking failed:', error.message);
      }
    };

    // Small delay to ensure page is actually rendered
    const timer = setTimeout(trackPageView, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null; // This component doesn't render anything
}
